import { getEnvVariable } from './runtime-env';

// SIP_DOMAIN = 'dev.s2.itgold.io' || 'sip.s2.itgold.io' || 'media.test.itgold.io'
export const SIP_DOMAIN = getEnvVariable('REACT_APP_SIP_DOMAIN') ?? 's2.itgold.io';

export const SIP_PROTOCOL = 'sip';
